module.exports = __webpack_public_path__ + "static/media/cards-r.ef7ef103.png";